import { type FC, useMemo } from 'react'

import { useParams } from '@tanstack/react-router'

import { useRegion } from '@/state/regions/useRegion'

import { PromotionUpdateFormPage } from './PromotionUpdateFormPage'

export interface RegionPromotionUpdateFormPageProps {
  onDirtyChange?: (isDirty: boolean) => void
}

export const RegionPromotionUpdateFormPage: FC<RegionPromotionUpdateFormPageProps> = ({ onDirtyChange }) => {
  const { initiativeId, regionId, promotionId } = useParams({
    from: '/promotions/$initiativeId/$regionId/$promotionId',
  })
  const { data: region } = useRegion({ regionId })
  const enabledPlacements = useMemo(
    () => Object.fromEntries(region?.promotionPlacements?.[initiativeId]?.map((placement) => [placement, true]) ?? []),
    [initiativeId, region?.promotionPlacements]
  )

  return (
    <PromotionUpdateFormPage
      initiativeId={initiativeId}
      promotionId={promotionId}
      enabledPlacements={enabledPlacements}
      metadata={{ initiativeId, regionId, promotionId, type: 'local' }}
      onDirtyChange={onDirtyChange}
    />
  )
}
